import axios from 'axios';

// Default API base — every route except /api/transactions/ai-categorize.
//   - Local dev:  http://localhost:5000 (the Express server)
//   - Production: the API Gateway HTTP API URL emitted by SAM (Output: ApiUrl)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// AI Categorize is routed separately because Claude calls run 10–60s and API
// Gateway hard-caps at 30s. In production it points at the Lambda Function URL
// (SAM Output: AiCategorizeUrl). Locally it falls back to the same Express
// server, which handles all routes uniformly — so local dev needs no extra
// env var; only production sets REACT_APP_AI_CATEGORIZE_URL.
const AI_CATEGORIZE_BASE_URL =
  process.env.REACT_APP_AI_CATEGORIZE_URL || API_BASE_URL;

// Shared interceptor wiring — every axios instance attaches the JWT and
// boots the user back to /login on a 401. Factor it out so the two
// instances can't drift.
const attachInterceptors = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});
attachInterceptors(api);

export const aiCategorizeApi = axios.create({
  baseURL: AI_CATEGORIZE_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  // Generous client-side ceiling — server side is the 120s Lambda timeout.
  timeout: 120_000,
});
attachInterceptors(aiCategorizeApi);

export default api;
